<template>
  <v-dialog
    v-model="$store.state.sessionSeriesDetails.nextEventsPopup"
    max-width="597"
  >
    <v-card color="#5271FF">
      <v-card-title>
        <v-col align="center" class="card-heading">
          Other Workshops Happening This Month
        </v-col>
      </v-card-title>
      <v-card-text class="">
        <div style="background: #4C6BFC;" class="pa-5">
          <v-row
            class="ma-0 mb-4"
            v-for="(event, index) in events"
            :key="index"
          >
            <div>
              <v-img
                width="48px"
                height="48px"
                style="border-radius: 50%;"
                aspect-ratio="1"
                :src="event.speaker_image"
              />
            </div>
            <v-col class="ms-n1 py-0 pt-2">
              <div class="upcoming-workshop-title">
                {{ event.title }}
              </div>
              <div class="upcoming-workshop-conductor">
                by {{ event.conductor_details.user_details.name }}
              </div>
            </v-col>
          </v-row>

          <v-col id="much-more" align="center">
            &amp; much more exclusive benefits
          </v-col>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "UpcomingEventsPopup",
    props: ["model", "events"],
    components: {},
    data() {
      return {};
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped>
  .card-heading {
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;

    color: rgba(255, 255, 255, 0.9);
  }
  .upcoming-workshop-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
  }
  .upcoming-workshop-conductor {
    font-size: 12px;
    line-height: 16px;
    color: rgba(255, 255, 255, 0.7);
  }
  #much-more {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #ffffff;
  }
</style>
